var _path, _rect, _rect2, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoShort(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 71,
    viewBox: "0 0 62 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.797 29.336C7.83295 29.336 3.96895 25.192 3.96895 18.78C3.96895 12.424 7.97295 8.196 13.965 8.196C18.809 8.196 22.421 11.024 23.121 15.42H19.341C18.641 13.04 16.597 11.64 13.881 11.64C10.101 11.64 7.72095 14.384 7.72095 18.752C7.72095 23.092 10.129 25.892 13.881 25.892C16.653 25.892 18.781 24.436 19.453 22.168H23.177C22.393 26.48 18.641 29.336 13.797 29.336ZM27.1987 29.336C25.9667 29.336 24.9307 28.328 24.9307 27.124C24.9307 25.892 25.9667 24.884 27.1987 24.884C28.4307 24.884 29.4667 25.892 29.4667 27.124C29.4667 28.328 28.4307 29.336 27.1987 29.336ZM35.9754 29H32.2514L39.6434 8.532H43.3114L50.7034 29H46.9234L45.2714 24.268H37.6274L35.9754 29ZM41.0154 14.636L38.6914 21.244H44.2354L41.8834 14.636C41.7154 14.104 41.5194 13.488 41.4634 13.068C41.3794 13.46 41.2114 14.076 41.0154 14.636ZM56.854 8.532V29H53.27V8.532H56.854Z",
    fill: "black"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 45,
    width: 62,
    height: 26,
    rx: 8,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 45,
    width: 62,
    height: 26,
    rx: 8,
    fill: "#FF4A00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5306 59.472H19.2766V63H17.4846V52.766H21.5306C23.5886 52.766 24.9186 54.11 24.9186 56.112C24.9186 58.086 23.5746 59.472 21.5306 59.472ZM21.1806 54.362H19.2766V57.876H21.1526C22.3846 57.876 23.0426 57.218 23.0426 56.098C23.0426 54.978 22.3706 54.362 21.1806 54.362ZM28.218 63H26.426V52.766H30.332C32.656 52.766 34.014 53.942 34.014 55.958C34.014 57.33 33.37 58.31 32.166 58.8L34.112 63H32.152L30.416 59.178H28.218V63ZM28.218 54.362V57.596H30.332C31.466 57.596 32.138 56.994 32.138 55.958C32.138 54.936 31.466 54.362 30.332 54.362H28.218ZM45.1156 57.876C45.1156 60.984 43.0716 63.168 40.1316 63.168C37.2056 63.168 35.1896 60.998 35.1896 57.876C35.1896 54.768 37.2196 52.584 40.1456 52.584C43.0716 52.584 45.1156 54.754 45.1156 57.876ZM43.2256 57.876C43.2256 55.692 42.0216 54.306 40.1456 54.306C38.2696 54.306 37.0656 55.692 37.0656 57.876C37.0656 60.06 38.2696 61.446 40.1456 61.446C42.0216 61.446 43.2256 60.032 43.2256 57.876Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoShort);
export default __webpack_public_path__ + "static/media/logoShort.bf2808f3ac643a4d9e2e4fc5fe0b073c.svg";
export { ForwardRef as ReactComponent };